import ConfigureOneProvider, { ConfigureOneContext } from './configureOne';

export { ConfigureOneProvider, ConfigureOneContext };



// WEBPACK FOOTER //
// ./src/contexts/index.js